import { get as _get } from 'lodash';
import {DetailsControlType} from 'shared/details-page/details-control/details-control-type';

export const columns: any = [
  {
    title: '',
    colSize: '4',
    sortable: false,
    sort: 'desc',
    active: false,
    col: 'part_image_small',
    type: 'image'
  },
  {
    title: 'Part No.',
    colSize: '4',
    sortable: false,
    active: false,
    link: true,
    permissions: ['admin', 'catalog-view', 'catalog-edit', 'repository'],
    col: 'partNumber',
  },
  {
    title: 'Description',
    colSize: '17',
    sortable: false,
    active: false,
    col: 'description',
    data: (row: any) => {
      return _get(row, 'descriptions.DES.EN');
    }
  },
  {
    title: 'Asset type',
    colSize: '4',
    sortable: false,
    active: false,
    col: 'file_type',
  },

  {
    title: 'Actual product',
    colSize: '6',
    sortable: false,
    active: false,
    col: 'actualProduct',
    data: (row: any) => {
      return 'Actual product';
    }
  },
];


export const marketcopyRowData: Array<any> = [
  {
    fieldName: 'name',
    width: '20%',
  }, {
    fieldName: 'code',
    width: '20%',
    type: DetailsControlType.Select,
  }, {
    fieldName: 'reference',
    width: '20%',
    type: DetailsControlType.Select,
  },
  {
    fieldName: 'assetType',
    width: '20%',
    type: DetailsControlType.Select,
  },
  {
    fieldName: 'representation',
    width: '20%',
    type: DetailsControlType.Select,
  }
];
